/* eslint-disable no-magic-numbers */
import * as yup from 'yup';
import { errorTexts } from '@features/errors';

export const transshipmentUpdateSchema = yup.object().shape({
  number: yup.string().required(errorTexts.required()),
  reloadDate: yup.object().required(errorTexts.required()),
});
